<template>
  <div>
    <section-header heading="2" ja="キャンペーン履歴"/>
    <template v-if="list">
      <template v-if="list.length === 0">
        <text-box title="キャンペーン履歴はないよ" />
      </template>
      <div class="history">
        <div v-for="(log,index) in list" :key="index">
          <hr>
          <div class="log">
            <div class="name" v-for="(name,index) in log.friendName" :key="index">
              <p>{{name ? name : 'ニックネーム未登録'}}</p>
            </div>
            <div class="date">
              <p>{{toDate(log.createTime)}}</p>
            </div>
          </div>
          <hr v-if="index+1 === list.length">
        </div>
      </div>
    </template>
    <sub-btn @click="onFriendCampaign()">戻る</sub-btn>
  </div>
</template>

<script>
import Protobuf from '../mixins/protobuf'
import SectionHeader from "../components/SectionHeader"
import SubBtn from '@/components/SubBtn.vue'
import TextBox from '@/components/TextBox.vue'
import { ymd } from "../assets/js/util"

const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web

export default {
  name: "FriendCampaignHistory",
  mixins: [Protobuf],
  components: {
    SectionHeader,
    SubBtn,
    TextBox,
  },
  data() {
    return {
      list: null,
    }
  },
  mounted() {
    const cmdNo = pb.CampaignFriendHistoryReq.CommandNo.COMMAND_NO
    const message = pb.CampaignFriendHistoryReq.create()
    const encoded = pb.CampaignFriendHistoryReq.encode(message).finish()
    this.post(cmdNo, encoded)
      .then(decoded => {
        if (decoded === undefined || decoded.playLogList === undefined) {
          this.$_error('Error', { title: '一緒にプリクラ！キャンペーン履歴', statusCode: 100 })
          return
        }
        // 0なら開催中
        if (decoded.status !== 0) {
          this.$router.push('/')
          return
        }
        this.list = decoded.playLogList;
      })
      .catch(() => {
        this.$_error('Error', { title: '一緒にプリクラ！キャンペーン履歴', statusCode: 100 })
      })
  },
  methods: {
    /**
     * 日付表示
     */
    toDate(intTime) {
      return ymd(intTime).join('.')
    },

    /**
     * 一緒にプリクラ！キャンペーンTOPに戻る
     */
    onFriendCampaign() {
      this.$router.push("/friendCampaign")
    },
  }
}
</script>

<style lang="scss" scoped>
.history {
  margin: 30px 0;
  .log {
    padding: 10px 30px;
    display: flex;
    justify-content: center;
    .name, .date { width: 50%; }
    .date { text-align: right; }
  }
}
</style>
